//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Addresscard from '../../svg/addresscard.vue';
export default {
    name: "index",
    // components: { Addresscard }
}
